import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/react';
import { UsageEnvelopeSchema } from '@agentbrush/shared';
import type { UsageResponseData } from '@agentbrush/shared';
import { useApiClient } from './use-api-client.js';

export type UsageData = UsageResponseData;

// Story 11.1 Task 0b: namespace React Query keys by Clerk userId so a session
// switch without full page reload cannot leak cached data between users.
export const usageQueryKey = (userId: string | null | undefined) =>
  ['usage', userId ?? 'anon'] as const;

export function useUsageQuery() {
  const { fetchApi } = useApiClient();
  const { userId } = useAuth();

  return useQuery<UsageData>({
    queryKey: usageQueryKey(userId),
    queryFn: async () => {
      const res = await fetchApi('/v1/usage');
      if (!res.ok) {
        throw new Error(`Status ${res.status}`);
      }

      const body = await res.json();
      return UsageEnvelopeSchema.parse(body).data;
    },
    enabled: Boolean(userId),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
